import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import React, { useMemo } from 'react'

const OverflowImage = ({
    children,
    containerSx,
    float,
}: {
    children: React.ReactNode
    maxHeight?: number
    containerSx?: React.CSSProperties
    float?: 'left' | 'right'
}) => {
    const devices = useDevice()

    const positionSx = {
        position: 'absolute',
        height: '100%',
        width: 'fit-content',
        top: '0px',
        ...(float === 'right' ? { right: '0px' } : { left: '0px' }),
    }

    const height = useMemo(() => {
        const { mdScreen, smScreen, xsScreen } = devices

        if (xsScreen) {
            return 496
        }

        if (smScreen) {
            return 271
        }

        if (mdScreen) {
            return 424
        }

        return 640
    }, [devices])

    return (
        <Box
            sx={{
                position: 'relative',
                height: `100%`,
                display: `flex`,
                flexDirection: `column`,
                justifyContent: `center`,
                alignItems: `center`,
            }}
        >
            <Box
                sx={{
                    ...positionSx,
                    ...(containerSx || {}),
                    height,
                    top: `50%`,
                    transform: `translateY(-50%)`,
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export default OverflowImage
